import { Users } from '../models/User.tsx';

export const RECIPIENT_CHIP_LIMIT = 5;
export const RECIPIENT_INLINE_LIMIT = 3;

export const BULK_RECIPIENT_LABELS: Record<string, string> = {
    allPlayer: 'All Players',
    allAgent: 'All Agents',
    all: 'All Players and Agents',
};

export function getRecipientSummary(recipients: string[], groupLabel?: string): string {
    const count = recipients?.length ?? 0;
    if (count === 0) return '—';
    if (groupLabel) return `${groupLabel} (${count})`;
    if (count === 1) return recipients[0];
    if (count <= RECIPIENT_INLINE_LIMIT) return recipients.join(', ');
    return `${count} recipients`;
}

export function shouldCollapseRecipients(recipients: string[], groupLabel?: string): boolean {
    if (groupLabel) return true;
    return (recipients?.length ?? 0) > RECIPIENT_CHIP_LIMIT;
}

export function filterMessagingUsers(users: Users[], queryText: string): Users[] {
    const text = queryText.toLowerCase().trim();
    if (!text) return [];

    return users.filter(user => {
        const userName = (user.userName || '').toLowerCase();
        const name = (user.name || '').toLowerCase();
        const pin = String(user.pin || '').toLowerCase();

        return userName.includes(text) || name.includes(text) || pin.includes(text);
    });
}

export function getMessagingRecipientsByType(
    type: string,
    allAgents: Users[],
    allPlayers: Users[]
): Users[] {
    switch (type) {
        case 'allPlayer':
            return allPlayers;
        case 'allAgent':
            return allAgents;
        case 'all':
            return [...allAgents, ...allPlayers];
        default:
            return [];
    }
}
